import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyFilterPipe } from './filter.pipe';
import { DistancePipe } from './distance.pipe';
import { KeyValuePipe } from './keyvalue.pipe';
import { CnpjPipe } from './cnpj.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';

export const COMPONENTS = [
  MyFilterPipe,
  DistancePipe,
  KeyValuePipe,
  CnpjPipe,
  SafeHtmlPipe
];

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS
})
export class PipesModule { }
